/**
 * Screen 1 — Identity Verification.
 *
 * A single input that accepts either a phone number or an email address.
 * Backend normalizes both server-side, so we don't need to detect locally;
 * we just trim whitespace.
 *
 * On 404 we display the exact copy mandated by Adjustment XIV.
 */

import React from 'react'
import Store from './../../RecruitingMeetingPage.store'

import './IdentityVerification.component.scss'

class IdentityVerification extends React.Component {
  handleChange = e => Store.setIdentifier(e.target.value)

  handleSubmit = e => {
    if (e && e.preventDefault) e.preventDefault()
    Store.verifyIdentity()
  }

  render() {
    const { identifierInput, verifying, errorMessage } = Store

    return (
      <form className='rm-verify' onSubmit={this.handleSubmit} noValidate>
        <div className='rm-verify__card'>
          <h1 className='rm-verify__heading'>Verify your booking</h1>
          <p className='rm-verify__subtitle'>
            Enter the <strong>email</strong> or <strong>phone number</strong> you used to register for today&apos;s
            meeting.
          </p>

          <label htmlFor='rm-verify-input' className='rm-verify__label'>
            Email or phone number
          </label>
          <input
            id='rm-verify-input'
            className='rm-verify__input'
            type='text'
            autoComplete='off'
            autoFocus
            placeholder='you@example.com  or  (555) 123-4567'
            value={identifierInput}
            onChange={this.handleChange}
            disabled={verifying}
          />

          <button type='submit' className='rm-verify__submit' disabled={verifying || !identifierInput.trim()}>
            {verifying ? 'Checking…' : 'Continue'}
          </button>

          {errorMessage && (
            <div className='rm-verify__error' role='alert'>
              {errorMessage}
            </div>
          )}
        </div>
      </form>
    )
  }
}

export default IdentityVerification
